import styled from 'styled-components';

const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  padding: 2rem 1rem;

  .shipping-container {
    width: 100%;
    max-width: 600px;
    background: var(--clr-white);
    padding: 2rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
  }

  .title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.5rem;
    
    h2 {
      color: var(--clr-primary-3);
      font-size: 1.5rem;
    }
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    
    @media (max-width: 576px) {
      grid-template-columns: 1fr;
    }
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    label {
      font-weight: 600;
      color: var(--clr-grey-3);
      font-size: 0.9rem;
    }

    &.full-width {
      width: 100%;
    }
  }

  .input {
    width: 100%;
    padding: 0.75rem 1rem;
    background: var(--clr-grey-10);
    border-radius: var(--radius);
    border: 1px solid var(--clr-grey-8);
    font-size: 1rem;
    transition: var(--transition);

    &:focus {
      outline: none;
      border-color: var(--clr-primary-5);
      box-shadow: 0 0 0 2px rgba(171, 129, 103, 0.2);
    }

    &::placeholder {
      color: var(--clr-grey-5);
    }
  }

  .shipping-btn {
    margin-top: 1rem;
    width: 100%;
    padding: 0.875rem 1.5rem;
    font-size: 1rem;
    font-weight: 600;
    background: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);

    &:hover {
      background: var(--clr-primary-3);
    }
  }
`;

const WrapperDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  
  .empty {
    text-align: center;
    
    h2 {
      margin-bottom: 1rem;
      color: var(--clr-grey-3);
    }
  }
`;

export { Wrapper, WrapperDiv };
